import React, { memo, forwardRef } from "react";
const SvgIntegers = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.1 23.32c-.347 0-.627-.047-.84-.14a1.498 1.498 0 01-.5-.38c-.107-.147-.18-.3-.22-.46-.04-.16-.06-.3-.06-.42 0-.427.24-.947.72-1.56l7.16-9h-6.54c-.267 0-.48-.04-.64-.12a1.295 1.295 0 01-.36-.28.912.912 0 01-.18-.36 1.776 1.776 0 01-.04-.34c0-.093.013-.2.04-.32a.767.767 0 01.18-.36c.093-.12.213-.22.36-.3.16-.08.373-.12.64-.12h8.2c.32 0 .58.053.78.16.2.093.353.213.46.36.107.147.18.3.22.46.04.16.06.293.06.4 0 .227-.047.453-.14.68-.093.213-.267.473-.52.78l-7.28 9.08h6.8c.267 0 .48.04.64.12.173.08.3.18.38.3.093.12.153.247.18.38.04.12.06.227.06.32s-.02.207-.06.34a.915.915 0 01-.18.36.888.888 0 01-.38.3c-.16.08-.373.12-.64.12h-8.3z"
      />
    </svg>
  );
});
SvgIntegers.displayName = "SvgIntegers";
const MemoForwardRef = memo(SvgIntegers);
export default MemoForwardRef;
